import {NxButton} from '@nextbank/ui-components';
import React, {useContext} from 'react';
import {SecurityContext} from '../../App';
import {hasExecutionReadonlyAccess} from '../../utils/permissions-utils';
import {TransHelper} from '../../utils/trans-helper';
import {NEW_LOAN_APPLICATION_PATH} from '../dashboard/routes/dashboard-routes';
import {useGuardedHistory} from '../router/GuardedHistory';
import Instruction from '../shared/instruction/Instruction';
import LoanApplicationDashboardTable from './dashboard/LoanApplicationDasboard';
import styles from './LoanApplications.module.scss';

export const TRANS_PREFIX = 'LOAN_APPLICATIONS';
export const PrefixTrans = TransHelper.getPrefixedTrans(TRANS_PREFIX);

const LoanApplications = (): React.ReactElement => {

  const history = useGuardedHistory();
  const {userData} = useContext(SecurityContext);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          <PrefixTrans>HEADER</PrefixTrans>
        </h1>
        <NxButton className={styles.button}
                  onClick={(): void => history.push(NEW_LOAN_APPLICATION_PATH)}
                  disabled={hasExecutionReadonlyAccess(userData)}>
          <PrefixTrans>NEW_LOAN</PrefixTrans>
        </NxButton>
      </div>
      <Instruction>
        <PrefixTrans>SELECT_EXISTING_LOAN_APPLICATION</PrefixTrans>
      </Instruction>
      <LoanApplicationDashboardTable />
    </div>
  );
};

export default LoanApplications;
